export default "__VITE_ASSET__DRYXCF$M__"